import getConfig from 'next/config';
import React from 'react';

import { SpecialOffers } from '@sravni/react-ugc/lib/SpecialOffers';
import { SpecialOffersForInsurance } from '@sravni/react-ugc/lib/SpecialOffersForInsurance';
import { useAnalytics, useBoolean, useIsMobile } from '@sravni/react-utils';
import { hasItem, makeTab } from '@sravni/ugc/lib/specialOffers/helpers';
import { ACTIONS } from '@sravni/ugc/lib/specialOffers/lists';
import { Tab } from '@sravni/ugc/lib/specialOffers/types';

import { AB_NAME } from '../../constants/sitesettings';

import styles from './special-offers-block.module.scss';

interface ISpecialOffersProps {
  tabs: Tab[];
  className?: string;
  isMainPage?: boolean;
  onHeightChange?: (height: number) => void;
}

const { specialOffersUrl } = getConfig().publicRuntimeConfig;

export const SpecialOffersBlock: React.FC<ISpecialOffersProps> = ({
  tabs,
  className,
  isMainPage = false,
  onHeightChange,
}) => {
  const isMobile = useIsMobile();
  const [isLoaded, toggleIsLoaded] = useBoolean();
  const { pushEvent } = useAnalytics();
  const isLoadRecentActions = hasItem(tabs, makeTab(ACTIONS.osago));

  if (!tabs.length) return null;

  const props = {
    heading: <div className={isMobile ? 'article-h4' : 'article-h3'} />,
    headingType: 'popover' as 'popover',
    pushEvent,
    abName: AB_NAME,
    isNarrowOnDesktop: true,
    isWithButtons: true,
    onLoad: toggleIsLoaded.on,
    iframeSrc: specialOffersUrl,
    onHeightChange,
  };

  return (
    <div className={className}>
      {!isLoaded && !isMainPage && <div className={styles.placeholder} />}
      {isLoadRecentActions ? <SpecialOffersForInsurance {...props} /> : <SpecialOffers {...props} tabs={tabs} />}
    </div>
  );
};
